import XLSX from "sheetjs-style";
import moment from "moment";

const colName = (n) => {
  let s = "";
  while (n >= 0) {
    s = String.fromCharCode((n % 26) + 65) + s;
    n = Math.floor(n / 26) - 1;
  }
  return s;
};

export const exportSummaryReportExcel = ({
  headerList = [],
  dataList = [],
} = {}) => {
  const arrayToExport = [];
  const mergedCellsForTotalDistance = [];
  const mergedCellsForDailyDitanceFare = [];
  const mergedCellsForTotalExpense = [];
  const mergedCellsForTotalAmount = [];
  const mergedCellsForOdometerReadings = [];
  const mergedCellsForOdometerDistance = [];

  let totalDistanceHeaderIndex = null;
  let dailyDistanceFareHeaderIndex = null;
  let totalExpenseHeaderIndex = null;
  let totalAmountHeaderIndex = null;
  let odometerReadingsHeaderIndex = null;
  let odometerDistanceHeaderIndex = null;

  headerList
    .filter((header) =>
      header.isStatic ? header.isShowOnWeb : header.IsShowWeb
    )
    .forEach((header, headerIndex) => {
      if (header.name === "Total Distance (Kms)" && header.isShowOnWeb) {
        totalDistanceHeaderIndex = headerIndex;
      } else if (
        header.name === "Daily Distance Fare (₹)" &&
        header.isShowOnWeb
      ) {
        dailyDistanceFareHeaderIndex = headerIndex;
      } else if (header.name === "Total Expense (₹)" && header.isShowOnWeb) {
        totalExpenseHeaderIndex = headerIndex;
      } else if (header.name === "Total Amount (₹)" && header.isShowOnWeb) {
        totalAmountHeaderIndex = headerIndex;
      } else if (header.name === "Odometer Details" && header.isShowOnWeb) {
        odometerReadingsHeaderIndex = headerIndex;
      } else if (header.name === "Odometer Distance" && header.isShowOnWeb) {
        odometerDistanceHeaderIndex = headerIndex;
      }
    });

  const rowsToColor = [];

  dataList.forEach((user, index) => {
    if (totalDistanceHeaderIndex !== null) {
      index === 0
        ? mergedCellsForTotalDistance.push({
            s: { r: 1, c: totalDistanceHeaderIndex },
            e: {
              r: user.clientCommunicationDtoList.length,
              c: totalDistanceHeaderIndex,
            },
          })
        : mergedCellsForTotalDistance.push({
            s: {
              r:
                mergedCellsForTotalDistance[
                  mergedCellsForTotalDistance.length - 1
                ].e.r + 1,
              c: totalDistanceHeaderIndex,
            },
            e: {
              r:
                mergedCellsForTotalDistance[
                  mergedCellsForTotalDistance.length - 1
                ].e.r + user.clientCommunicationDtoList.length,
              c: totalDistanceHeaderIndex,
            },
          });
    }

    if (dailyDistanceFareHeaderIndex !== null) {
      index === 0
        ? mergedCellsForDailyDitanceFare.push({
            s: { r: 1, c: dailyDistanceFareHeaderIndex },
            e: {
              r: user.clientCommunicationDtoList.length,
              c: dailyDistanceFareHeaderIndex,
            },
          })
        : mergedCellsForDailyDitanceFare.push({
            s: {
              r:
                mergedCellsForDailyDitanceFare[
                  mergedCellsForDailyDitanceFare.length - 1
                ].e.r + 1,
              c: dailyDistanceFareHeaderIndex,
            },
            e: {
              r:
                mergedCellsForDailyDitanceFare[
                  mergedCellsForDailyDitanceFare.length - 1
                ].e.r + user.clientCommunicationDtoList.length,
              c: dailyDistanceFareHeaderIndex,
            },
          });
    }

    if (totalExpenseHeaderIndex) {
      index === 0
        ? mergedCellsForTotalExpense.push({
            s: { r: 1, c: totalExpenseHeaderIndex },
            e: {
              r: user.clientCommunicationDtoList.length,
              c: totalExpenseHeaderIndex,
            },
          })
        : mergedCellsForTotalExpense.push({
            s: {
              r:
                mergedCellsForTotalExpense[
                  mergedCellsForTotalExpense.length - 1
                ].e.r + 1,
              c: totalExpenseHeaderIndex,
            },
            e: {
              r:
                mergedCellsForTotalExpense[
                  mergedCellsForTotalExpense.length - 1
                ].e.r + user.clientCommunicationDtoList.length,
              c: totalExpenseHeaderIndex,
            },
          });
    }

    if (totalAmountHeaderIndex !== null) {
      index === 0
        ? mergedCellsForTotalAmount.push({
            s: { r: 1, c: totalAmountHeaderIndex },
            e: {
              r: user.clientCommunicationDtoList.length,
              c: totalAmountHeaderIndex,
            },
          })
        : mergedCellsForTotalAmount.push({
            s: {
              r:
                mergedCellsForTotalAmount[mergedCellsForTotalAmount.length - 1]
                  .e.r + 1,
              c: totalAmountHeaderIndex,
            },
            e: {
              r:
                mergedCellsForTotalAmount[mergedCellsForTotalAmount.length - 1]
                  .e.r + user.clientCommunicationDtoList.length,
              c: totalAmountHeaderIndex,
            },
          });
    }

    if (odometerReadingsHeaderIndex !== null) {
      index === 0
        ? mergedCellsForOdometerReadings.push({
            s: { r: 1, c: odometerReadingsHeaderIndex },
            e: {
              r: user.clientCommunicationDtoList.length,
              c: odometerReadingsHeaderIndex,
            },
          })
        : mergedCellsForOdometerReadings.push({
            s: {
              r:
                mergedCellsForOdometerReadings[
                  mergedCellsForOdometerReadings.length - 1
                ].e.r + 1,
              c: odometerReadingsHeaderIndex,
            },
            e: {
              r:
                mergedCellsForOdometerReadings[
                  mergedCellsForOdometerReadings.length - 1
                ].e.r + user.clientCommunicationDtoList.length,
              c: odometerReadingsHeaderIndex,
            },
          });
    }

    if (odometerDistanceHeaderIndex !== null) {
      index === 0
        ? mergedCellsForOdometerDistance.push({
            s: { r: 1, c: odometerDistanceHeaderIndex },
            e: {
              r: user.clientCommunicationDtoList.length,
              c: odometerDistanceHeaderIndex,
            },
          })
        : mergedCellsForOdometerDistance.push({
            s: {
              r:
                mergedCellsForOdometerDistance[
                  mergedCellsForOdometerDistance.length - 1
                ].e.r + 1,
              c: odometerDistanceHeaderIndex,
            },
            e: {
              r:
                mergedCellsForOdometerDistance[
                  mergedCellsForOdometerDistance.length - 1
                ].e.r + user.clientCommunicationDtoList.length,
              c: odometerDistanceHeaderIndex,
            },
          });
    }

    user.clientCommunicationDtoList.forEach((communication) => {
      const objToPush = {};
      headerList.forEach((header) => {
        console.log({user, communication, header});
        if (header.isStatic && header.isShowOnWeb) {
          let valueToSet = "";
          if (header.name === "Date") {
            valueToSet = communication.createdDateTime
              ? moment(communication.createdDateTime).format(
                  "DD/MM/YYYY hh:mm A"
                )
              : " ";
          } else if (header.name === "Meeting Start Time") {
            valueToSet = communication.meetingOnDateTime
              ? moment(communication.meetingOnDateTime).format(
                  "DD/MM/YYYY hh:mm A"
                )
              : " ";
          } else if (header.name === "Meeting End Time") {
            valueToSet = communication.meetingOffDateTime
              ? moment(communication.meetingOffDateTime).format(
                  "DD/MM/YYYY hh:mm A"
                )
              : " ";
          } else if (header.name === "Meeting Start Location") {
            valueToSet = communication.startAddress || " ";
          } else if (header.name === "Meeting End Location") {
            valueToSet = communication.address || " ";
          } else if (header.name === "Meeting Duration") {
            valueToSet = communication.meetingDuration || " ";
          } else if (header.name === "Od Date/Time") {
            valueToSet = `Start: ${
              user.createdDate
                ? moment(user.createdDate).format("hh:mm A")
                : " "
            }, End: ${user.date ? moment(user.date).format("hh:mm A") : " "}`;
          } else if (header.name === "Client/Vendor Name") {
            valueToSet = communication.clientName || " ";
          } else if (header.name === "Contact Person") {
            valueToSet = communication.contactPerson || " ";
          } else if (header.name === "Emp Name (Emp Code)") {
            valueToSet = `${user.userName || " "} (${user.empCode || " "})`;
          } else if (header.name === "Client Status") {
            valueToSet = communication?.clientCurrentStatus?.statusName || " ";
          } else if (header.name === "Client Type") {
            valueToSet = communication.clientType || " ";
          } else if (header.name === "Contact Person Name") {
            valueToSet = communication.contactPersonNo || " ";
          } else if (header.name === "Meeting Type") {
            valueToSet = communication.mode || " ";
          } else if (header.name === "Reason") {
            valueToSet = communication.reason || " ";
          } else if (header.name === "Discussion Summary") {
            valueToSet = communication.conclusion || " ";
          } else if (header.name === "Remarks") {
            valueToSet = communication.remarks || " ";
          } else if (header.name === "Place Of Visit") {
            valueToSet = communication.visitPlace || " ";
          } else if (header.name === "Distance") {
            valueToSet = `${
              communication.meetingDistance
                ? communication.meetingDistance
                : "0.00"
            }`;
          } else if (header.name === "Meeting Distance Fare (Rs)") {
            valueToSet = `${
              communication.distanceFare !== null && communication.distanceFare !== undefined
                ? communication.distanceFare.toFixed(2)
                : "0.00"
            }`;
          } else if (header.name === "Meeting Expense Amount (Rs)") {
            valueToSet = `${
              communication.clientTotalExpenseAmount !== null && communication.clientTotalExpenseAmount !== undefined
                ? communication.clientTotalExpenseAmount.toFixed(2)
                : "0.00"
            }`;
          } else if (header.name === "Total Distance (Kms)") {
            valueToSet = `${
              user.totalDistance !== null && user.totalDistance !== undefined
                ? user.totalDistance.toFixed(2)
                : "0.00"
            }`;
          } else if (header.name === "Daily Distance Fare (Rs)") {
            valueToSet = `${
              user.totalAmountForOd !== null && user.totalAmountForOd !== undefined
                ? user.totalAmountForOd.toFixed(2)
                : "0.00"
            }`;
          } else if (header.name === "Total Expense (Rs)") {
            valueToSet = `${
              user.odExpenseAmount !== null && user.odExpenseAmount !== undefined
                ? user.odExpenseAmount.toFixed(2)
                : "0.00"
            }`;
          } else if (header.name === "Total Amount (Rs)") {
            valueToSet = `Approved: ${
              user.totalApprovedExpenseAndFareAmount !== null && user.totalApprovedExpenseAndFareAmount !== undefined
                ? user.totalApprovedExpenseAndFareAmount.toFixed(2)
                : "0.00"
            }, Rejected: ${
              user.totalRejectedExpenseAndFareAmount !== null && user.totalRejectedExpenseAndFareAmount !== undefined
                ? user.totalRejectedExpenseAndFareAmount.toFixed(2)
                : "0.00"
            }, Pending: ${
              user.totalPendingExpenseAndFareAmount !== null && user.totalPendingExpenseAndFareAmount !== undefined
                ? user.totalPendingExpenseAndFareAmount.toFixed(2)
                : "0.00"
            }, Total: ${
              user.totalExpenseAndFareAmount !== null && user.totalExpenseAndFareAmount !== undefined
                ? user.totalExpenseAndFareAmount.toFixed(2)
                : "0.00"
            }`;
          } else if (header.name === "Odometer Details") {
            valueToSet = `Start: ${
              user.odoMeterStartReading !== null && user.odoMeterStartReading !== undefined
                ? user.odoMeterStartReading.toFixed(2)
                : "NA"
            }, End: ${
              user.odoMeterEndReading !== null && user.odoMeterEndReading !== undefined
                ? user.odoMeterEndReading.toFixed(2)
                : "NA"
            }`;
          } else if (header.name === "Odometer Distance") {
            valueToSet = `Distance: ${
              user.odoMeterDistanceDifference !== null && user.odoMeterDistanceDifference !== undefined
                ? user.odoMeterDistanceDifference.toFixed(2)
                : "NA"
            }`;
          }
          objToPush[header.displayName] = valueToSet;
        } else if (!header.isStatic && header.IsShowWeb) {
          const jsonMapData = communication.formData
            ? Object.fromEntries(
                communication.formData.map((data) => [data.uid, data.value])
              )
            : {};
          // objToPush[header.label] = jsonMapData[header.uid] || " ";
          objToPush[header.label] =
            jsonMapData[header.uid] instanceof Array
              ? jsonMapData[header.uid].join(", ")
              : typeof jsonMapData[header.uid] === "boolean"
              ? jsonMapData[header.uid]
                ? "Yes"
                : "No"
              : jsonMapData[header.uid] || " ";
        }
      });
      arrayToExport.push(objToPush);

      if (communication.meetingSubmitedFromOtherLocation) {
        rowsToColor.push(arrayToExport.length + 1);
      }
    });
  });

  // fallback
  if (arrayToExport.length === 0) {
    const objToPush = {};
    headerList.forEach((header) => {
      if (header.isStatic && header.isShowOnWeb) {
        objToPush[header.displayName] = "";
      } else if (!header.isStatic && header.IsShowWeb) {
        objToPush[header.label] = "";
      }
    });
    arrayToExport.push(objToPush);
  }

  const worksheet = XLSX.utils.json_to_sheet(arrayToExport);

  rowsToColor.forEach((rowToColorIndex) => {
    for (let i = 0; i < Object.keys(arrayToExport[0]).length; i++) {
      if (
        ![
          totalDistanceHeaderIndex,
          dailyDistanceFareHeaderIndex,
          totalExpenseHeaderIndex,
          totalAmountHeaderIndex,
          odometerReadingsHeaderIndex,
          odometerDistanceHeaderIndex,
        ].includes(i)
      ) {
        worksheet[`${colName(i)}${rowToColorIndex}`].s = {
          fill: {
            fgColor: { rgb: "FFFFCCCB" },
          },
        };
      }
    }
  });

  const range = XLSX.utils.decode_range(worksheet["!ref"]);

  worksheet["!cols"] = [];
  for (let i = range.s.c; i <= range.e.c; i++) {
    worksheet["!cols"].push({ width: 15 });
    worksheet[`${colName(i)}1`].s = {
      font: {
        bold: true,
      },
    };
  }

  worksheet["!merges"] = [
    ...mergedCellsForTotalDistance,
    ...mergedCellsForDailyDitanceFare,
    ...mergedCellsForTotalExpense,
    ...mergedCellsForTotalAmount,
    ...mergedCellsForOdometerReadings,
    ...mergedCellsForOdometerDistance,
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

  XLSX.writeFile(workbook, "Summary Reports.xlsx", {
    compression: true,
    defaultCellStyle: {
      font: {
        sz: 10,
      },
    },
  });
};

export const exportEmployeewiseReportExcel = ({
  headerList = [],
  dataList = [],
  userId = null,
  fromDate = null,
  toDate = null,
} = {}) => {
  const employeewiseDataList = Array.from(
    dataList
      .reduce((prev, curr) => {
        if (userId === null || userId === curr.userId) {
          // (prev[curr.userId] = prev[curr.userId] || []).push(curr);
          if (prev.get(curr.userId)) {
            const prevVal = prev.get(curr.userId);
            prevVal.push(curr);
            // prev.set(curr.userId, prevVal);
          } else {
            prev.set(curr.userId, [curr]);
          }
        }
        return prev;
      }, new Map())
      .values()
  );

  const employeeWiseInfoHeaderList = [
    "Emp Name",
    "From Date",
    "To Date",
    "Total Meetings",
    "New Client",
    "Unique Clients",
    "Working Days",
    "Expense",
    "Total Distance",
  ];
  const employeeWiseTableHeadersList = headerList.reduce((prev, curr) => {
    if (curr.isStatic && curr.isShowOnWeb) {
      prev.push(curr.displayName);
    } else if (!curr.isStatic && curr.IsShowWeb) {
      prev.push(curr.label);
    }
    return prev;
  }, []);

  const arrayToExport = [];
  const mergedCellsForTotalDistance = [];
  const mergedCellsForDailyDitanceFare = [];
  const mergedCellsForTotalExpense = [];
  const mergedCellsForTotalAmount = [];
  const mergedCellsForOdometerReadings = [];
  const mergedCellsForOdometerDistance = [];

  let totalDistanceHeaderIndex = null;
  let dailyDistanceFareHeaderIndex = null;
  let totalExpenseHeaderIndex = null;
  let totalAmountHeaderIndex = null;
  let odometerReadingsHeaderIndex = null;
  let odometerDistanceHeaderIndex = null;

  const headerRowsIndex = [];

  headerList
    .filter((header) =>
      header.isStatic ? header.isShowOnWeb : header.IsShowWeb
    )
    .forEach((header, headerIndex) => {
      if (header.name === "Total Distance (Kms)" && header.isShowOnWeb) {
        totalDistanceHeaderIndex = headerIndex;
      } else if (
        header.name === "Daily Distance Fare (Rs)" &&
        header.isShowOnWeb
      ) {
        dailyDistanceFareHeaderIndex = headerIndex;
      } else if (header.name === "Total Expense (Rs)" && header.isShowOnWeb) {
        totalExpenseHeaderIndex = headerIndex;
      } else if (header.name === "Total Amount (Rs)" && header.isShowOnWeb) {
        totalAmountHeaderIndex = headerIndex;
      } else if (header.name === "Odometer Details" && header.isShowOnWeb) {
        odometerReadingsHeaderIndex = headerIndex;
      } else if (header.name === "Odometer Distance" && header.isShowOnWeb) {
        odometerDistanceHeaderIndex = headerIndex;
      }
    });

  const rowsToColor = [];

  employeewiseDataList.forEach((employee, employeeIndex) => {
    arrayToExport.push(employeeWiseInfoHeaderList);
    headerRowsIndex.push(arrayToExport.length);
    arrayToExport.push([
      `${employee[0]?.userName} (${employee[0]?.empCode})`,
      fromDate,
      toDate,
      employee.reduce((prev, curr) => prev + (curr.totalVisit || 0), 0),
      employee.reduce(
        (prev, curr) => prev + (curr.totalClientNewCommunication || 0),
        0
      ),
      employee.reduce((prev, curr) => prev + (curr.totalUniqueClient || 0), 0),
      employee.length,
      employee.reduce(
        (prev, curr) => prev + (curr.totalApprovedExpenseAndFareAmount || 0),
        0
      ),
      employee.reduce((prev, curr) => prev + (curr.totalDistance || 0), 0),
    ]);
    arrayToExport.push(employeeWiseTableHeadersList);
    headerRowsIndex.push(arrayToExport.length);
    employee.forEach((user, userIndex) => {
      if (totalDistanceHeaderIndex !== null) {
        employeeIndex === 0 && userIndex === 0
          ? mergedCellsForTotalDistance.push({
              s: { r: 3, c: totalDistanceHeaderIndex },
              e: {
                r: user.clientCommunicationDtoList.length + 2,
                c: totalDistanceHeaderIndex,
              },
            })
          : mergedCellsForTotalDistance.push({
              s: {
                r:
                  mergedCellsForTotalDistance[
                    mergedCellsForTotalDistance.length - 1
                  ].e.r + (userIndex === 0 ? 4 : 1),
                c: totalDistanceHeaderIndex,
              },
              e: {
                r:
                  mergedCellsForTotalDistance[
                    mergedCellsForTotalDistance.length - 1
                  ].e.r +
                  user.clientCommunicationDtoList.length -
                  1 +
                  (userIndex === 0 ? 4 : 1),
                c: totalDistanceHeaderIndex,
              },
            });
      }

      if (dailyDistanceFareHeaderIndex !== null) {
        employeeIndex === 0 && userIndex === 0
          ? mergedCellsForDailyDitanceFare.push({
              s: { r: 3, c: dailyDistanceFareHeaderIndex },
              e: {
                r: user.clientCommunicationDtoList.length + 2,
                c: dailyDistanceFareHeaderIndex,
              },
            })
          : mergedCellsForDailyDitanceFare.push({
              s: {
                r:
                  mergedCellsForDailyDitanceFare[
                    mergedCellsForDailyDitanceFare.length - 1
                  ].e.r + (userIndex === 0 ? 4 : 1),
                c: dailyDistanceFareHeaderIndex,
              },
              e: {
                r:
                  mergedCellsForDailyDitanceFare[
                    mergedCellsForDailyDitanceFare.length - 1
                  ].e.r +
                  user.clientCommunicationDtoList.length -
                  1 +
                  (userIndex === 0 ? 4 : 1),
                c: dailyDistanceFareHeaderIndex,
              },
            });
      }

      if (totalExpenseHeaderIndex) {
        employeeIndex === 0 && userIndex === 0
          ? mergedCellsForTotalExpense.push({
              s: { r: 3, c: totalExpenseHeaderIndex },
              e: {
                r: user.clientCommunicationDtoList.length + 2,
                c: totalExpenseHeaderIndex,
              },
            })
          : mergedCellsForTotalExpense.push({
              s: {
                r:
                  mergedCellsForTotalExpense[
                    mergedCellsForTotalExpense.length - 1
                  ].e.r + (userIndex === 0 ? 4 : 1),
                c: totalExpenseHeaderIndex,
              },
              e: {
                r:
                  mergedCellsForTotalExpense[
                    mergedCellsForTotalExpense.length - 1
                  ].e.r +
                  user.clientCommunicationDtoList.length -
                  1 +
                  (userIndex === 0 ? 4 : 1),
                c: totalExpenseHeaderIndex,
              },
            });
      }

      if (totalAmountHeaderIndex !== null) {
        employeeIndex === 0 && userIndex === 0
          ? mergedCellsForTotalAmount.push({
              s: { r: 3, c: totalAmountHeaderIndex },
              e: {
                r: user.clientCommunicationDtoList.length + 2,
                c: totalAmountHeaderIndex,
              },
            })
          : mergedCellsForTotalAmount.push({
              s: {
                r:
                  mergedCellsForTotalAmount[
                    mergedCellsForTotalAmount.length - 1
                  ].e.r + (userIndex === 0 ? 4 : 1),
                c: totalAmountHeaderIndex,
              },
              e: {
                r:
                  mergedCellsForTotalAmount[
                    mergedCellsForTotalAmount.length - 1
                  ].e.r +
                  user.clientCommunicationDtoList.length -
                  1 +
                  (userIndex === 0 ? 4 : 1),
                c: totalAmountHeaderIndex,
              },
            });
      }

      if (odometerReadingsHeaderIndex !== null) {
        employeeIndex === 0 && userIndex === 0
          ? mergedCellsForOdometerReadings.push({
              s: { r: 3, c: odometerReadingsHeaderIndex },
              e: {
                r: user.clientCommunicationDtoList.length + 2,
                c: odometerReadingsHeaderIndex,
              },
            })
          : mergedCellsForOdometerReadings.push({
              s: {
                r:
                  mergedCellsForOdometerReadings[
                    mergedCellsForOdometerReadings.length - 1
                  ].e.r + (userIndex === 0 ? 4 : 1),
                c: odometerReadingsHeaderIndex,
              },
              e: {
                r:
                  mergedCellsForOdometerReadings[
                    mergedCellsForOdometerReadings.length - 1
                  ].e.r +
                  user.clientCommunicationDtoList.length -
                  1 +
                  (userIndex === 0 ? 4 : 1),
                c: odometerReadingsHeaderIndex,
              },
            });
      }

      if (odometerDistanceHeaderIndex !== null) {
        employeeIndex === 0 && userIndex === 0
          ? mergedCellsForOdometerDistance.push({
              s: { r: 3, c: odometerDistanceHeaderIndex },
              e: {
                r: user.clientCommunicationDtoList.length + 2,
                c: odometerDistanceHeaderIndex,
              },
            })
          : mergedCellsForOdometerDistance.push({
              s: {
                r:
                  mergedCellsForOdometerDistance[
                    mergedCellsForOdometerDistance.length - 1
                  ].e.r + (userIndex === 0 ? 4 : 1),
                c: odometerDistanceHeaderIndex,
              },
              e: {
                r:
                  mergedCellsForOdometerDistance[
                    mergedCellsForOdometerDistance.length - 1
                  ].e.r +
                  user.clientCommunicationDtoList.length -
                  1 +
                  (userIndex === 0 ? 4 : 1),
                c: odometerDistanceHeaderIndex,
              },
            });
      }

      user.clientCommunicationDtoList.forEach((communication) => {
        const arrayToPush = [];

        headerList.forEach((header) => {
          if (header.isStatic && header.isShowOnWeb) {
            let valueToSet = "";
            if (header.name === "Date") {
              valueToSet = communication.createdDateTime
                ? moment(communication.createdDateTime).format(
                    "DD/MM/YYYY hh:mm A"
                  )
                : " ";
            } else if (header.name === "Meeting Start Time") {
              valueToSet = communication.meetingOnDateTime
                ? moment(communication.meetingOnDateTime).format(
                    "DD/MM/YYYY hh:mm A"
                  )
                : " ";
            } else if (header.name === "Meeting End Time") {
              valueToSet = communication.meetingOffDateTime
                ? moment(communication.meetingOffDateTime).format(
                    "DD/MM/YYYY hh:mm A"
                  )
                : " ";
            } else if (header.name === "Meeting Start Location") {
              valueToSet = communication.startAddress || " ";
            } else if (header.name === "Meeting End Location") {
              valueToSet = communication.address || " ";
            } else if (header.name === "Meeting Duration") {
              valueToSet = communication.meetingDuration || " ";
            } else if (header.name === "Od Date/Time") {
              valueToSet = `Start: ${
                user.createdDate
                  ? moment(user.createdDate).format("hh:mm A")
                  : " "
              }, End: ${user.date ? moment(user.date).format("hh:mm A") : " "}`;
            } else if (header.name === "Client/Vendor Name") {
              valueToSet = communication.clientName;
            } else if (header.name === "Contact Person") {
              valueToSet = communication.contactPerson || " ";
            } else if (header.name === "Emp Name (Emp Code)") {
              valueToSet = `${user.userName || " "} (${user.empCode || " "})`;
            } else if (header.name === "Client Status") {
              valueToSet =
                communication?.clientCurrentStatus?.statusName || " ";
            } else if (header.name === "Client Type") {
              valueToSet = communication.clientType || " ";
            } else if (header.name === "Contact Person Name") {
              valueToSet = communication.contactPersonNo || " ";
            } else if (header.name === "Meeting Type") {
              valueToSet = communication.mode || " ";
            } else if (header.name === "Reason") {
              valueToSet = communication.reason || " ";
            } else if (header.name === "Discussion Summary") {
              valueToSet = communication.conclusion || " ";
            } else if (header.name === "Remarks") {
              valueToSet = communication.remarks || " ";
            } else if (header.name === "Place Of Visit") {
              valueToSet = communication.visitPlace || " ";
            } else if (header.name === "Distance") {
              valueToSet = `${
                communication.meetingDistance
                  ? communication.meetingDistance
                  : "0.00"
              }`;
            } else if (header.name === "Meeting Distance Fare (Rs)") {
              valueToSet = `${
                communication.distanceFare
                  ? communication.distanceFare.toFixed(2)
                  : "0.00"
              }`;
            } else if (header.name === "Meeting Expense Amount (Rs)") {
              valueToSet = `${
                communication.clientTotalExpenseAmount
                  ? communication.clientTotalExpenseAmount.toFixed(2)
                  : "0.00"
              }`;
            } else if (header.name === "Total Distance (Kms)") {
              valueToSet = `${
                user.totalDistance ? user.totalDistance.toFixed(2) : "0.00"
              }`;
            } else if (header.name === "Daily Distance Fare (Rs)") {
              valueToSet = `${
                user.totalAmountForOd
                  ? user.totalAmountForOd.toFixed(2)
                  : "0.00"
              }`;
            } else if (header.name === "Total Expense (Rs)") {
              valueToSet = `${
                user.odExpenseAmount ? user.odExpenseAmount.toFixed(2) : "0.00"
              }`;
            } else if (header.name === "Total Amount (Rs)") {
              valueToSet = `Approved: ${
                user.totalApprovedExpenseAndFareAmount
                  ? user.totalApprovedExpenseAndFareAmount.toFixed(2)
                  : "0.00"
              }, Rejected: ${
                user.totalRejectedExpenseAndFareAmount
                  ? user.totalRejectedExpenseAndFareAmount.toFixed(2)
                  : "0.00"
              }, Pending: ${
                user.totalPendingExpenseAndFareAmount
                  ? user.totalPendingExpenseAndFareAmount.toFixed(2)
                  : "0.00"
              }, Total: ${
                user.totalExpenseAndFareAmount
                  ? user.totalExpenseAndFareAmount.toFixed(2)
                  : "0.00"
              }`;
            } else if (header.name === "Odometer Details") {
              valueToSet = `Start: ${
                user.odoMeterStartReading
                  ? user.odoMeterStartReading.toFixed(2)
                  : "NA"
              }, End: ${
                user.odoMeterEndReading
                  ? user.odoMeterEndReading.toFixed(2)
                  : "NA"
              }`;
            } else if (header.name === "Odometer Distance") {
              valueToSet = `Distance: ${
                user.odoMeterDistanceDifference
                  ? user.odoMeterDistanceDifference.toFixed(2)
                  : "NA"
              }`;
            }
            arrayToPush.push(valueToSet);
          } else if (!header.isStatic && header.IsShowWeb) {
            const jsonMapData = communication.formData
              ? Object.fromEntries(
                  communication.formData.map((data) => [data.uid, data.value])
                )
              : {};
            // arrayToPush.push(jsonMapData[header.uid] || " ");
            arrayToPush.push(
              jsonMapData[header.uid] instanceof Array
                ? jsonMapData[header.uid].join(", ")
                : typeof jsonMapData[header.uid] === "boolean"
                ? jsonMapData[header.uid]
                  ? "Yes"
                  : "No"
                : jsonMapData[header.uid] || " "
            );
          }
        });
        arrayToExport.push(arrayToPush);

        if (communication.meetingSubmitedFromOtherLocation) {
          rowsToColor.push(arrayToExport.length);
        }
      });
    });
  });

  const worksheet = XLSX.utils.aoa_to_sheet(arrayToExport);

  rowsToColor.forEach((rowToColorIndex) => {
    for (let i = 0; i < employeeWiseTableHeadersList.length; i++) {
      if (
        ![
          totalDistanceHeaderIndex,
          dailyDistanceFareHeaderIndex,
          totalExpenseHeaderIndex,
          totalAmountHeaderIndex,
          odometerReadingsHeaderIndex,
          odometerDistanceHeaderIndex,
        ].includes(i)
      ) {
        const cellAddress = `${colName(i)}${rowToColorIndex}`;

        worksheet[cellAddress].s = {
          fill: {
            fgColor: { rgb: "FFFFCCCB" },
          },
        };
      }
    }
  });

  if (arrayToExport.length) {
    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    worksheet["!cols"] = [];
    for (let i = range.s.c; i <= range.e.c; i++) {
      worksheet["!cols"].push({ width: 15 });
    }
  }

  headerRowsIndex.forEach((rowHeaderIndex, rowHeaderArrayIndex) => {
    if (rowHeaderArrayIndex % 2 === 0) {
      for (let i = 0; i < employeeWiseInfoHeaderList.length; i++) {
        worksheet[`${colName(i)}${rowHeaderIndex}`].s = {
          font: {
            bold: true,
          },
        };
      }
    } else {
      for (let i = 0; i < employeeWiseTableHeadersList.length; i++) {
        worksheet[`${colName(i)}${rowHeaderIndex}`].s = {
          font: {
            bold: true,
          },
        };
      }
    }
  });

  worksheet["!merges"] = [
    ...mergedCellsForTotalDistance,
    ...mergedCellsForDailyDitanceFare,
    ...mergedCellsForTotalExpense,
    ...mergedCellsForTotalAmount,
    ...mergedCellsForOdometerReadings,
    ...mergedCellsForOdometerDistance,
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

  XLSX.writeFile(workbook, "Employeewise Reports.xlsx", {
    compression: true,
    defaultCellStyle: {
      font: {
        sz: 10,
      },
    },
  });
};
